import { callPost } from "../../lib/api-private";
import { TriggerRequest } from "../../generated-client/model/trigger-request";

export const triggerMobilePay = async (
  accessToken: string,
  data: TriggerRequest
): Promise<void> => {
  return await callPost(accessToken, "/mobilePay/trigger/", data);
};
